<template>
    <v-container fluid>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate />
        </v-overlay>

        <!-- 週移動 -->
        <v-row>
            <v-col>
                <v-btn width="100" color="primary" @click="lastWeek"> ＜＜前週 </v-btn>
            </v-col>

            <v-col class="text-center">
                <v-btn width="100" color="primary" @click="thisWeek"> 今週 </v-btn>
            </v-col>

            <v-col class="text-right">
                <v-btn width="100" color="primary" @click="nextWeek"> 次週＞＞ </v-btn>
            </v-col>
        </v-row>

        <!-- カレンダー -->
        <v-row>
            <v-col>
                <v-card class="mt-3 pb-5">
                    <v-sheet :height="calendarHeight">
                        <h1 class="text-center pa-3">{{ dbDevice.name }}</h1>
                        <v-calendar ref="calendar" :now="today" :value="dispDate" :events="events" :weekdays="weekdays" :interval-height="intervalHeight" interval-width="40" color="primary" type="week" locale="jp" @click:event="feedPlanClick" />
                        <h5 class="text-center">{{ dispWeekSpan }}</h5>
                    </v-sheet>
                    <!-- カレンダー高さ変更 -->
                    <v-speed-dial v-model="speedDialSlide" direction="bottom" top left transition="scale-transition" style="position: absolute">
                        <template v-slot:activator>
                            <v-btn v-model="speedDialSlide" color="purple darken-1" dark fab>
                                <v-icon v-if="speedDialSlide"> mdi-close </v-icon>
                                <v-icon v-else> mdi-arrow-expand-vertical </v-icon>
                            </v-btn>
                        </template>
                        <v-card outlined height="200" width="60" color="grey">
                            <v-slider v-model="intervalHeight" vertical min="30" max="1200" @change="setIntervalHeight" />
                        </v-card>
                    </v-speed-dial>

                    <!-- 新規プラン -->
                    <v-speed-dial v-model="speedDialBtn" direction="left" bottom right transition="scale-transition" style="position: absolute">
                        <template v-slot:activator>
                            <v-btn v-model="speedDialBtn" color="purple darken-1" dark fab>
                                <v-icon v-if="speedDialBtn"> mdi-close </v-icon>
                                <v-icon v-else> mdi-plus </v-icon>
                            </v-btn>
                        </template>
                        <v-btn dark small color="green" @click="newFeedPlanClick('timer')"> タイマー </v-btn>
                        <v-btn dark small color="warning" @click="newFeedPlanClick('self')"> 自発 </v-btn>
                        <v-btn dark small color="pink" @click="newFeedPlanClick('ai')"> AI </v-btn>
                    </v-speed-dial>
                </v-card>
            </v-col>
        </v-row>

        <!-- 削除確認 -->
        <v-dialog v-model="confirmDeleteDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark> 確認 </v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgFeedPlan.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" @click="axiosDeleteFeedPlan">削除！</v-btn>
                    <v-spacer />
                    <v-btn width="100" color="success" outlined @click="confirmDeleteDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 給餌プラン設定 -->
        <v-dialog v-model="dispPlanDlg" fullscreen transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="indigo">
                    <v-toolbar-title>給餌プラン設定</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="dispPlanDlg = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- 共通設定 -->
                <v-card-text class="mt-5 pr-0">
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="dlgFeedPlan.name" label="タイトル" dense :rules="[rules.required]" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-dialog ref="stimeDialog" v-model="dispClockDlg" :return-value.sync="dlgFeedPlan.stime" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dlgFeedPlan.stime" label="開始時刻" readonly dense v-bind="attrs" v-on="on" />
                                    </template>
                                    <v-time-picker v-if="dispClockDlg" v-model="dlgFeedPlan.stime" full-width format="24hr">
                                        <v-spacer />
                                        <v-btn text color="primary" @click="dispClockDlg = false"> Cancel </v-btn>
                                        <v-btn text color="primary" @click="$refs.stimeDialog.save(dlgFeedPlan.stime)"> OK </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                            <v-col>
                                <v-select v-model="dlgFeedPlan.minutes" label="動作時間(分)" :items="optMinutes" dense :rules="[rules.required]" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                                <v-select v-model="dlgFeedPlan.routine" label="ルーティーン" :items="optRoutines" multiple dense @change="routineChange" />
                            </v-col>

                            <v-col>
                                <v-dialog ref="zeroDateDialog" v-model="dispMonthDlg" :return-value.sync="dlgFeedPlan.zero_date" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dlgFeedPlan.zero_date" label="中日計算基準日" readonly dense v-bind="attrs" v-on="on" />
                                    </template>

                                    <v-date-picker v-model="dlgFeedPlan.zero_date" locale="jp" :max="today">
                                        <v-spacer />
                                        <v-btn text color="primary" @click="dispMonthDlg = false"> Cancel </v-btn>

                                        <v-btn text color="primary" @click="$refs.zeroDateDialog.save(dlgFeedPlan.zero_date)"> OK </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider />
                <!-- モード別設定 -->
                <v-card-text class="mt-5 pr-0">
                    <!-- Timer -->
                    <v-container v-if="dlgFeedPlan.mode === 'timer'">
                        <v-row>
                            <v-col>
                                <h5>給餌量（{{ outputMin }} kg 〜 {{ outputMax }} kg）</h5>
                                <v-text-field v-model="dlgFeedPlan.detail.timer_weight" class="mt-0 pt-0" hide-details single-line step="0.1" inputmode="decimal" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>飛散レベル</h5>
                                <v-slider v-model="dlgFeedPlan.splinkle" class="align-center" max="9" min="1" hide-details>
                                    <template v-slot:append>
                                        <v-text-field v-model="dlgFeedPlan.splinkle" class="mt-0 pt-0" hide-details single-line type="number" style="width: 100px" readonly />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>
                    </v-container>

                    <!-- Self -->
                    <v-container v-else-if="dlgFeedPlan.mode === 'self'">
                        <v-row>
                            <v-col>
                                <h5>1回あたりの給餌量(0.1kg 〜 3.0kg)</h5>
                                <v-text-field v-model="dlgFeedPlan.detail.self_shot_weight" class="mt-0 pt-0" hide-details single-line step="0.1" inputmode="decimal" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>飛散レベル</h5>
                                <v-slider v-model="dlgFeedPlan.splinkle" max="9" min="1" hide-details>
                                    <template v-slot:append>
                                        <v-text-field v-model="dlgFeedPlan.splinkle" hide-details single-line type="number" style="width: 60px" readonly />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>日の出増量時間(分)</h5>
                                <v-slider v-model="dlgFeedPlan.detail.self_sunrise" max="90" min="0" step="15" hide-details>
                                    <template v-slot:append>
                                        <v-text-field v-model="dlgFeedPlan.detail.self_sunrise" hide-details single-line type="number" style="width: 60px" readonly />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>日の入り増量時間(分)</h5>
                                <v-slider v-model="dlgFeedPlan.detail.self_sunset" max="90" min="0" step="15" hide-details>
                                    <template v-slot:append>
                                        <v-text-field v-model="dlgFeedPlan.detail.self_sunset" hide-details single-line type="number" style="width: 60px" readonly />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>朝夕増量(倍率)</h5>
                                <v-slider v-model="dlgFeedPlan.detail.self_extra" max="3" min="0" step="0.5" hide-details>
                                    <template v-slot:append>
                                        <v-text-field v-model="dlgFeedPlan.detail.self_extra" hide-details single-line type="number" style="width: 60px" readonly />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-select v-model="dlgFeedPlan.detail.self_region_code" outlined dense label="地域コード" :items="optSelfRegion" />
                            </v-col>
                        </v-row>
                    </v-container>

                    <!-- AI -->
                    <v-container v-else-if="dlgFeedPlan.mode === 'ai'">
                        <h2 class="mb-5">■引寄せ給餌</h2>

                        <v-row class="px-5">
                            <v-col cols="6" class="py-0">
                                <v-select v-model="dlgFeedPlan.detail.ai_start_motor" outlined dense label="引寄せ給餌速度" :items="optMotor" />
                            </v-col>

                            <v-col cols="6" class="py-0">
                                <v-select v-model="dlgFeedPlan.detail.ai_start_delay" outlined dense label="引寄せ時間" :items="optSecounds" />
                            </v-col>
                        </v-row>

                        <h2 class="mb-5">■AI判定給餌</h2>

                        <v-row v-for="level in aiLevels" :key="level" class="px-5">
                            <v-col class="py-0">
                                <v-select v-model="dlgFeedPlan.detail[`ai_lvl${level}_motor`]" outlined dense :label="`活性度${level}の給餌速度`" :items="optMotor" />
                            </v-col>
                        </v-row>

                        <h2 class="mb-5">■AI判定感度</h2>

                        <v-row class="px-5">
                            <v-col cols="6" class="py-0">
                                <v-select v-model="dlgFeedPlan.detail.ai_sensitive" outlined dense label="感度" :items="optAiSensitive" />
                            </v-col>
                        </v-row>

                        <h2 class="mb-5">■AI給餌サイクル</h2>

                        <v-row class="px-5">
                            <v-col cols="6" class="py-0">
                                <v-select v-model="dlgFeedPlan.detail.ai_repeat" outlined dense label="サイクル数" :items="optAiRepeat" />
                            </v-col>

                            <v-col cols="6" class="py-0">
                                <v-select v-model="dlgFeedPlan.detail.ai_repeat_interval" outlined dense label="インターバル" :items="optIntervals" />
                            </v-col>
                        </v-row>

                        <h2 class="mb-5">■その他設定</h2>

                        <v-row class="px-5">
                            <v-col class="py-0">
                                <v-select v-model="dlgFeedPlan.splinkle" outlined dense label="飛散レベル" :items="optMotorSprinkle" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider />
                <!-- 保存 -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col v-if="dlgFeedPlan.id > 0" class="text-center pa-0">
                            <v-btn color="error" width="100" @click="confirmDeleteDlg = true"> 削除 </v-btn>
                        </v-col>

                        <v-col class="text-center pa-0">
                            <v-btn color="success" width="100" outlined @click="dispPlanDlg = false"> キャンセル </v-btn>
                        </v-col>

                        <v-col class="text-center pa-0">
                            <v-btn color="success" width="100" @click="axiosSubmitFeedPlan"> 登録 </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Config from "@/config.json";
import mqtt from "mqtt";
//#####################################################################################################
const WEEKDAYS = ["日", "月", "火", "水", "木", "金", "土"];
const ROUTINE_DAILY = "毎日";
const ROUTINE_WEEKDAYS = ["月", "火", "水", "木", "金", "土", "日"];
const ROUTINE_INTERVALS = ["中一", "中二", "中三", "中四", "中五"];
const ROUTINE_INTERVAL_DAYS = {
    中一: 2,
    中二: 3,
    中三: 4,
    中四: 5,
    中五: 6,
    中六: 7,
};
const MODE_COLORS = {
    timer: "green",
    self: "orange",
    ai: "pink",
};
//#####################################################################################################
export default {
    name: "FeedPlan",
    //######################################
    props: {
        device_id: {
            type: [String, Number],
            required: true,
        },
    },
    //######################################
    data() {
        return {
            jwt: "",
            myInfo: [],

            dbDevice: {
                id: 0,
                name: "",
                feeder_id: 0,
            },

            dbFeeder: {
                id: 0,
                name: "",
                pellet: "",
                output1: "1000",
                output9: "9000",
            },

            dbFeedPlans: [],

            // MQTT
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mqttClient: {
                connected: false,
            },

            // Calendar
            intervalHeight: 80,
            dispDate: this.$moment().format("YYYY-MM-DD"),
            today: this.$moment().format("YYYY-MM-DD"),
            events: [],
            weekdays: [0, 1, 2, 3, 4, 5, 6],

            // Dialog
            dlgFeedPlan: this.createDefaultFeedPlan(),
            dispPlanDlg: false,
            dispMonthDlg: false,
            dispClockDlg: false,
            confirmDeleteDlg: false,

            optAiSensitive: [
                { value: "1", text: "高" },
                { value: "2", text: "中" },
                { value: "3", text: "低" },
            ],

            optMotor: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map((value) => ({
                value: String(value),
                text: String(value),
            })),

            optMotorSprinkle: [9, 8, 7, 6, 5, 4, 3, 2, 1].map((value) => ({
                value: value,
                text: String(value),
            })),

            optSecounds: [
                { value: "0", text: "なし" },
                ...[3, 5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 220, 240, 260, 280, 300].map((value) => ({
                    value: String(value),
                    text: `${value}秒`,
                })),
            ],

            optIntervals: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 220, 240, 260, 280, 300].map((value) => ({
                value: String(value),
                text: `${value}秒`,
            })),

            optRoutines: [
                { value: "毎日", text: "毎日", disabled: false },
                { divider: true },
                { value: "月", text: "月曜", disabled: false },
                { value: "火", text: "火曜", disabled: false },
                { value: "水", text: "水曜", disabled: false },
                { value: "木", text: "木曜", disabled: false },
                { value: "金", text: "金曜", disabled: false },
                { value: "土", text: "土曜", disabled: false },
                { value: "日", text: "日曜", disabled: false },
                { divider: true },
                { value: "中一", text: "中1日", disabled: false },
                { value: "中二", text: "中2日", disabled: false },
                { value: "中三", text: "中3日", disabled: false },
                { value: "中四", text: "中4日", disabled: false },
                { value: "中五", text: "中5日", disabled: false },
            ],

            optMinutes: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "20", "30", "40", "50", "60", "90", "120"],

            optAiRepeat: ["1", "2", "3", "4", "5"],

            optSelfRegion: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"],

            // Output
            outputMin: 0.001,
            outputMax: 99,

            // UI
            speedDialSlide: false,
            speedDialBtn: false,

            aiLevels: [5, 4, 3, 2, 1],

            rules: {
                required: (value) => !!value || "Required.",
            },

            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,

            isLoading: false,
        };
    },
    //######################################
    created() {
        if (!this.initializeAuth()) {
            return;
        }
        const savedIntervalHeight = this.$localStorage.get("intervalHeight");
        if (savedIntervalHeight) {
            this.intervalHeight = Number(savedIntervalHeight);
        }
        this.connectMqtt();
        //window.scrollTo(0, 0);
    },
    //######################################
    watch: {
        device_id: {
            immediate: true,
            async handler(newDeviceId) {
                await this.loadDeviceData(newDeviceId);
            },
        },
        "dlgFeedPlan.minutes"() {
            this.calcOutputMinMax();
        },
    },
    //######################################
    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.$nextTick(() => {
            if (!this.$refs.calendar) {
                return;
            }
            const thisTime = this.$moment().subtract(3, "hours").format("HH:mm");
            this.$refs.calendar.scrollToTime(thisTime);
        });
    },
    //######################################
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        this.disconnectMqtt();
    },
    //######################################
    computed: {
        dispWeekSpan() {
            const weekNo = this.$moment(this.dispDate).day();
            const startDate = this.$moment(this.dispDate).subtract(weekNo, "day").format("YYYY/M/D");
            const endDate = this.$moment(this.dispDate)
                .add(6 - weekNo, "day")
                .format("M/D");
            return `${startDate} 〜 ${endDate}`;
        },
        calendarHeight() {
            return Math.max(window.innerHeight - 250, 300);
        },
    },
    //######################################
    methods: {
        // ============================================================
        // 初期値
        // ============================================================
        createDefaultFeedPlan() {
            return {
                id: 0,
                site_id: 0,
                device_id: 0,
                feeder_id: 0,
                mode: "ai",
                name: "タイトル",
                stime: "06:30",
                minutes: "90",
                routine: ["月", "水", "金"],
                zero_date: this.$moment().format("YYYY-MM-DD"),
                splinkle: 3,

                detail: {
                    timer_weight: "100",

                    ai_start_motor: "3",
                    ai_start_delay: "10",
                    ai_lvl5_motor: "9",
                    ai_lvl4_motor: "7",
                    ai_lvl3_motor: "5",
                    ai_lvl2_motor: "2",
                    ai_lvl1_motor: "0",
                    ai_sensitive: "1",
                    ai_repeat: "1",
                    ai_repeat_interval: "10",

                    self_shot_weight: "10",
                    self_sunrise: "15",
                    self_sunset: "15",
                    self_extra: "1.5",
                    self_region_code: "A",
                },
            };
        },
        // ============================================================
        // Auth
        // ============================================================
        initializeAuth() {
            this.jwt = this.$localStorage.get("jwt");
            if (!this.jwt) {
                this.$router.push({ name: "Login" });
                return false;
            }
            this.myInfo = this.$jwt.decode(this.jwt);
            if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
                this.$router.push({ name: "Login" });
                return false;
            }
            return true;
        },
        // ============================================================
        // Device data
        // ============================================================
        async loadDeviceData(deviceId) {
            this.isLoading = true;
            try {
                await this.axiosGetDevices(deviceId);
                await Promise.all([this.axiosGetFeeders(this.dbDevice.feeder_id), this.axiosGetFeedPlan(deviceId)]);
            } catch (error) {
                this.handleApiError(error);
            } finally {
                // 既存仕様の待ち時間を維持
                await this.sleep(500);
                this.isLoading = false;
            }
        },
        // ============================================================
        // Calendar
        // ============================================================
        thisWeek() {
            this.changeWeek(this.$moment());
        },
        nextWeek() {
            this.changeWeek(this.$moment(this.dispDate).add(7, "days"));
        },
        lastWeek() {
            this.changeWeek(this.$moment(this.dispDate).subtract(7, "days"));
        },
        changeWeek(date) {
            this.dispDate = date.format("YYYY-MM-DD");
            this.createWeekEvent();
        },
        setIntervalHeight() {
            this.$localStorage.set("intervalHeight", this.intervalHeight);
        },
        createWeekEvent() {
            const events = [];
            for (const feedPlan of this.dbFeedPlans) {
                for (let offset = -7; offset <= 7; offset++) {
                    const date = this.$moment(this.dispDate).add(offset, "day");

                    if (!this.shouldDisplayFeedPlan(feedPlan, date)) {
                        continue;
                    }
                    const start = `${date.format("YYYY-MM-DD")} ${feedPlan.stime}`;
                    const end = this.$moment(start).add(Number(feedPlan.minutes), "minutes").format("YYYY-MM-DD HH:mm");

                    events.push({
                        id: feedPlan.id,
                        primaryKey: feedPlan.id,
                        name: feedPlan.name,
                        start,
                        end,
                        color: MODE_COLORS[feedPlan.mode] || "black",
                    });
                }
            }
            this.events = events;
        },
        shouldDisplayFeedPlan(feedPlan, date) {
            // 過去日は表示しない
            if (date.isBefore(this.$moment(this.today), "day")) {
                return false;
            }
            const routine = feedPlan.routine || [];
            if (routine.includes(ROUTINE_DAILY)) {
                return true;
            }
            const weekday = WEEKDAYS[date.day()];
            if (routine.includes(weekday)) {
                return true;
            }
            const zeroDate = this.$moment(feedPlan.zero_date);
            const diffDay = date.diff(zeroDate, "days");
            return routine.some((item) => {
                const interval = ROUTINE_INTERVAL_DAYS[item];
                return interval && diffDay % interval === 0;
            });
        },
        // ============================================================
        // Routine
        // 選択項目によって、他をDisabledにする
        //
        // const ROUTINE_DAILY = "毎日";
        // const ROUTINE_WEEKDAYS = ["月", "火", "水", "木", "金", "土", "日"];
        // const ROUTINE_INTERVALS = ["中一", "中二", "中三", "中四", "中五"];
        // ============================================================
        routineChange(selected) {
            const values = selected || [];
            if (values.length === 0) {
                this.setRoutineDisabled([]);
                return;
            }
            if (values.includes(ROUTINE_DAILY)) {
                this.applyRoutineSelection([ROUTINE_DAILY]);
                return;
            }
            const selectedWeekdays = values.filter((value) => ROUTINE_WEEKDAYS.includes(value));
            if (selectedWeekdays.length > 0) {
                this.applyRoutineSelection(ROUTINE_WEEKDAYS);
                return;
            }
            const selectedInterval = values.find((value) => ROUTINE_INTERVALS.includes(value));
            if (selectedInterval) {
                this.applyRoutineSelection([selectedInterval]);
            }
        },
        applyRoutineSelection(allowedValues) {
            this.setRoutineDisabled(allowedValues);
            this.dlgFeedPlan.routine = this.dlgFeedPlan.routine.filter((value) => allowedValues.includes(value));
        },
        setRoutineDisabled(allowedValues) {
            this.optRoutines.forEach((item) => {
                if (!item.value) {
                    return;
                }
                item.disabled = allowedValues.length > 0 && !allowedValues.includes(item.value);
            });
        },
        // ============================================================
        // Feed Plan Dialog
        // ============================================================
        newFeedPlanClick(feedMode) {
            const plan = this.createDefaultFeedPlan();
            plan.mode = feedMode;
            plan.name = "新規プラン";
            plan.stime = this.$moment().format("HH:mm");
            plan.minutes = "30";
            plan.routine = ["毎日"];
            plan.zero_date = this.$moment().format("YYYY-MM-DD");
            this.dlgFeedPlan = plan;
            this.routineChange(plan.routine);
            this.calcOutputMinMax();
            this.dispPlanDlg = true;
        },
        feedPlanClick({ event }) {
            const plan = this.dbFeedPlans.find((item) => item.id === event.primaryKey);
            if (!plan) {
                return;
            }
            this.dlgFeedPlan = this.deepClone(plan);
            this.routineChange(this.dlgFeedPlan.routine);
            this.calcOutputMinMax();
            this.dispPlanDlg = true;
        },
        // ============================================================
        // Output
        // ============================================================
        calcOutputMinMax() {
            const minutes = Number(this.dlgFeedPlan.minutes) || 0;
            const output9 = Number(this.dbFeeder.output9) || 0;
            const output1 = Number(this.dbFeeder.output1) || 0;
            // 最大給餌量 kg
            let max = (output9 * minutes) / 1000;
            max = Math.round(max * 10) / 10;
            this.outputMax = max <= 0 ? 0.1 : max;
            // 最小給餌量 kg
            let min = (output1 / 60) * minutes;
            min = min / 1000;
            min = Math.round(min * 10) / 10;
            this.outputMin = Math.max(min, 0.1);
        },
        // ============================================================
        // Validation
        // ============================================================
        validateFeedPlan() {
            const plan = this.dlgFeedPlan;
            if (!plan.name || !plan.stime || !plan.minutes || !plan.routine.length) {
                alert("未入力項目があります。");
                return false;
            }
            if (plan.mode === "timer") {
                return this.validateWeight(plan.detail.timer_weight, this.outputMin, this.outputMax, "給餌量");
            }
            if (plan.mode === "self") {
                return this.validateWeight(plan.detail.self_shot_weight, 0.1, 3.0, "1回あたりの給餌量");
            }
            return true;
        },
        validateWeight(value, min, max, label) {
            const weight = Number(value);
            if (!Number.isFinite(weight) || Math.round(weight * 10) / 10 !== weight) {
                alert("給餌量の値が不正です。");
                return false;
            }
            if (weight < min || weight > max) {
                alert(`${label}が範囲を超えています。`);
                return false;
            }
            return true;
        },
        // ============================================================
        // API
        // ============================================================
        async axiosGetDevices(deviceId) {
            const response = await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    id: deviceId,
                    "_order[sort_no]": "asc",
                },
                headers: this.authHeaders(),
                timeout: 30000,
            });
            this.dbDevice = response.data.json[0] || {
                id: 0,
                name: "",
                feeder_id: 0,
            };
        },
        async axiosGetFeeders(feederId) {
            const response = await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: {
                    id: feederId,
                    "_order[sort_no]": "asc",
                },
                headers: this.authHeaders(),
                timeout: 30000,
            });

            this.dbFeeder = response.data.json[0] || this.dbFeeder;
        },

        async axiosGetFeedPlan(deviceId = this.device_id) {
            const response = await this.axios({
                method: "GET",
                url: "/web/api/feed_plans",
                params: {
                    device_id: deviceId,
                },
                headers: this.authHeaders(),
                timeout: 30000,
            });
            this.dbFeedPlans = (response.data.json || []).map(this.normalizeFeedPlan);
            this.createWeekEvent();
        },

        normalizeFeedPlan(plan) {
            return {
                ...plan,
                detail: this.parseJsonField(plan.detail, {}),
                routine: this.parseJsonField(plan.routine, []),
            };
        },

        parseJsonField(value, defaultValue) {
            if (Array.isArray(value) || typeof value === "object") {
                return value;
            }
            try {
                const normalized = String(value).replace(/\\"/g, '"');
                return JSON.parse(normalized);
            } catch (error) {
                console.warn("JSON parse failed:", value);
                return defaultValue;
            }
        },
        async axiosSubmitFeedPlan() {
            if (!this.validateFeedPlan()) {
                return false;
            }
            this.isLoading = true;
            this.dispPlanDlg = false;
            try {
                const axiosData = this.createSubmitData();
                const id = this.dlgFeedPlan.id;
                await this.axios({
                    method: id > 0 ? "PUT" : "POST",
                    url: id > 0 ? `/web/api/feed_plans/${id}` : "/web/api/feed_plans",
                    headers: this.authHeaders(),
                    data: axiosData,
                    timeout: 30000,
                });

                await this.axiosGetFeedPlan();

                this.mqttFeedPlansChange();
            } catch (error) {
                this.handleFeedPlanSaveError(error);
            } finally {
                await this.sleep(1000);
                this.isLoading = false;
            }
        },

        createSubmitData() {
            const data = this.deepClone(this.dlgFeedPlan);
            data.site_id = this.myInfo.site_id;
            data.device_id = this.device_id;
            data.feeder_id = this.dbDevice.feeder_id;
            data.routine = JSON.stringify(data.routine);
            data.detail = JSON.stringify(data.detail);
            return data;
        },

        async axiosDeleteFeedPlan() {
            this.confirmDeleteDlg = false;
            this.dispPlanDlg = false;
            this.isLoading = true;

            try {
                await this.axios({
                    method: "DELETE",
                    url: `/web/api/feed_plans/${this.dlgFeedPlan.id}`,
                    headers: this.authHeaders(),
                    timeout: 30000,
                });

                await this.axiosGetFeedPlan();

                this.mqttFeedPlansChange();
            } catch (error) {
                this.handleApiError(error);
            } finally {
                await this.sleep(1000);
                this.isLoading = false;
            }
        },
        // ============================================================
        // API Helpers
        // ============================================================
        authHeaders() {
            const token = this.$localStorage.get("jwt");
            return {
                Authorization: `Bearer ${token}`,
            };
        },
        handleFeedPlanSaveError(error) {
            const err = error?.response?.data?.err;
            if (err === "ER_DUP_ENTRY") {
                alert("重複しています。\n保存できません。");
                return;
            }
            this.handleApiError(error);
        },
        handleApiError(error) {
            console.error(error);
            const message = error?.response?.data?.err || error?.message || "通信エラーが発生しました。";
            alert(message);
        },
        // ============================================================
        // MQTT
        // ============================================================
        async connectMqtt() {
            if (this.mqttClient.connected) return;
            this.mqttClient = mqtt.connect(
                this.mqttHost
                // {
                //     username: this.mqttID,
                //     password: this.mqttPW,
                // }
            );
            this.mqttClient.on("connect", () => {
                console.log("MQTT Connected !!");
            });
            this.mqttClient.on("error", (error) => {
                console.error("MQTT Error:", error);
            });
        },
        disconnectMqtt() {
            console.log("・・・・MQTT disconnect !!");
            if (!this.mqttClient.connected) return;
            this.mqttClient.end();
        },
        publishMessage(mac, key, val) {
            if (!this.mqttClient.connected) return;
            const topic = `${this.mqttTopicPub}/${mac}`;
            const message = { type: "order", key, val, mac };
            this.mqttClient.publish(topic, JSON.stringify(message));
        },
        mqttFeedPlansChange() {
            this.publishMessage(this.dbDevice.mac, "feed_plans", "change");
        },
        // ============================================================
        // Utility
        // ============================================================
        deepClone(value) {
            return JSON.parse(JSON.stringify(value));
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
    },
};
</script>
